import React from 'react';
import { Dialog, DialogContent } from '@mui/material';
import AiChat from './index';

const ChatDialog = ({ open, onClose, chatType }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
      fullWidth
      PaperProps={{
        style: {
          height: '80%',
          margin: 0,
          padding: 0,
          maxHeight: '80%',
        },
      }}
    >
      <DialogContent
        style={{
          height: '100%',
          padding: 0,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '100%',
            overflowY: 'hidden',
          }}
        >
          <AiChat chatType={chatType} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ChatDialog;
